<template>
  <div class="payment-info">
    <div class="info-item">
      <div class="info-title">
        <div class="title">결제 수단</div>
        <div class="checkbox-wrapper" v-if="isPerson">
          <input
            type="checkbox"
            v-model="isCheck"
            id="paymentInfoCheckbox"
            class="common"
          />
          <label for="paymentInfoCheckbox"
            >선택한 결제수단을 다음에도 사용</label
          >
        </div>
      </div>

      <div class="info-content">
        <div class="content">
          <!-- 일반 결제 -->
          <!-- <div class="direct-card-wrapper" v-if="canUseDirectCard">
            <div class="direct-card-input">
              <input
                type="radio"
                id="direct-card"
                name="paymentMethodList"
                class="common"
                :value="PAYMENT_METHOD.DIRECT_CARD"
                v-model="paymentMethod"
              />
              <label for="direct-card">일반 결제</label>
            </div>
          </div> -->

          <hr v-if="canUseDirectCard && canUseLater" />

          <!-- 후불결제 -->
          <div class="later-wrapper" v-if="canUseLater">
            <div class="later-input">
              <input
                type="radio"
                id="later"
                name="paymentMethodList"
                class="common"
                :value="PAYMENT_METHOD.LATER"
                v-model="paymentMethod"
                checked="true"
              />
              <label for="later">후불결제</label>
            </div>

            <!-- <div class="later-text" v-if="paymentMethod === PAYMENT_METHOD.LATER">
              랩매니저 스토어는, 주문이 끝나면 상품부터 먼저 받아 보실 수 있는 후불결제 방식입니다.<br />
              당월 출고된 전체 상품에 대하여, 매월 말일에 세금계산서가 일괄적으로 발행됩니다.<br />
              세금계산서 발행분에 대한 입금 기한은, 세금계산서 발행일로부터 1개월입니다.<br />
              전월 세금계산서 발행분에 대한 대금이 익월 말까지 입금되지 않는 경우, 스토어 내 상품 주문이 제한됩니다.<br />
              후불결제 서비스의 금액 한도는 3백만원입니다. 미결제 금액이 3백만원을 초과한 경우, 스토어 내 상품 주문이 제한됩니다.
            </div> -->
          </div>

          <!-- 아무 것도 허용되지 않을 때 -->
          <div v-if="!canUseDirectCard && !canUseLater" class="text-sm">
            현재 기관 유형에서는 사용 가능한 결제수단이 없습니다. 관리자에
            문의해 주세요.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import cookies from "vue-cookies";

const PAYMENT_METHOD = {
  DIRECT_CARD: "DIRECT_CARD",
  LATER: "LATER",
};

const INSTITUTE_TYPE = {
  PERSON: "PERSON",
  UNIVERSITY: "UNIVERSITY",
  ENTERPRISE: "ENTERPRISE",
  SELLER: "SELLER",
};

export default {
  name: "PaymentInfo",
  data() {
    return {
      PAYMENT_METHOD,
      isCheck: false,
			paymentMethod: PAYMENT_METHOD.LATER,
		}
  },
  computed: {
    ...mapState("user", ["institute"]),

    instituteType() {
      if (this.$_.isEmpty(this.institute)) return null;
      return this.institute.type?.code || null;
    },
    isPerson() {
      return this.instituteType === INSTITUTE_TYPE.PERSON;
    },

    // 기관 유형별 허용 결제수단 정의
    allowedByType() {
      return {
        [INSTITUTE_TYPE.PERSON]: [this.PAYMENT_METHOD.LATER],
        [INSTITUTE_TYPE.SELLER]: [this.PAYMENT_METHOD.LATER],
        [INSTITUTE_TYPE.UNIVERSITY]: [this.PAYMENT_METHOD.LATER],
        [INSTITUTE_TYPE.ENTERPRISE]: [this.PAYMENT_METHOD.LATER],
      };
    },
    allowedMethods() {
      return this.allowedByType[this.instituteType] || [];
    },

    canUseDirectCard() {
      return this.allowedMethods.includes(this.PAYMENT_METHOD.DIRECT_CARD);
    },
    canUseLater() {
      return this.allowedMethods.includes(this.PAYMENT_METHOD.LATER);
    },
  },
  watch: {
    // 기관 변경 시 기본값 재설정 (쿠키 무시하고 무조건 LATER로 설정)
    allowedMethods: {
			handler(newMethods) {
				if (newMethods.length > 0) {
					// 쿠키 삭제 및 무조건 후불결제로 설정
					cookies.remove('paymentMethod')
					this.paymentMethod = this.PAYMENT_METHOD.LATER
					// eslint-disable-next-line no-console
					console.log('[PaymentInfo] paymentMethod set to:', this.paymentMethod)
				}
			},
			immediate: true,
    },
  },
  methods: {
    getPaymentInfo() {
      return {
        paymentMethod: this.paymentMethod,
        isRememberPaymentMethod: this.isCheck,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-info {
  display: flex;
  flex-direction: column;
  .info-item {
    display: flex;
    flex-direction: column;
    gap: 15px;
    .info-title {
      display: flex;
      .title {
        font-weight: bold;
        font-size: 1.25rem;
      }
      .checkbox-wrapper {
        display: flex;
        align-items: center;
        margin-left: 15px;
        label {
          font-size: 0.875rem;
          font-weight: 700;
          cursor: pointer;
        }
      }
    }
    .info-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 20px;
      border: 1px solid $COLOR_DDD;
      border-radius: 5px;
      .content {
        div + div {
          margin-top: 10px;
        }
        .direct-card-input,
        .later-input {
          height: 20px;
          display: flex;
          align-items: center;
          font-weight: 500;
          label {
            margin-left: 10px;
          }
        }
        .later-text {
          font-size: 0.875rem;
          font-weight: 500;
        }
        hr {
          border: 1px solid $LINE_DIVIDER;
        }
      }
    }
  }
}
</style>
